module.exports = __webpack_public_path__ + "media/reskin-images/icon--case-active-f37e07db.svg";